import ZtyHeaderLinks from "@/components/Header/ZtyHeaderLinks";
import API from "../../../config/api";

var headerMixin = {
    data() {
        return {
            activePageLinkIndex: '2',
            userLink: [  //手机可能才用
                {url: `/pages/login/PcLogin`, name: '登录', index: '0'},
                {url: `/pages/login/UserRegister`, name: '注册', index: '1'},
            ],
            userAfLink: [   //只保留了电脑端的
                {url: `/pages/userCenter/UserCenter`, name: '个人中心', index: '0'},
            ],
            user: undefined,
        }
    },
    created() {
        this.$bus.$on('header-refresh', this.init)
    },
    destroyed() {
        this.$bus.$off('header-refresh', this.init)
    },
    mounted() {
        this.init()
    },
    methods: {
        init() {
            if (window.localStorage.getItem("user")) {
                this.user = JSON.parse(window.localStorage.getItem("user"));
                console.log(this.user);
            }
        },
        goOn: function (url) {
            this.$router.push({path: url})   //点击头像或用户名进入个人中心
        },
        clearUser: function () {
            this.$confirm('确认注销?', '提示', {
                customClass: 'dialog-message',
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                //调用后端接口清除session
                let header = {
                    "Content-Type": "application/x-www-form-urlencoded"
                }
                this.$axiosRequest({
                    url: API.userLogout,
                    method: 'POST',
                    data: {},
                    header: header,
                    success: res => {
                        console.log(res.data)
                        if (res.data == 0) {
                            this.$message({
                                type: 'success',
                                message: '注销成功!'
                            });
                            window.localStorage.removeItem("user")
                            window.localStorage.removeItem("userid")
                            window.localStorage.removeItem("token")
                            window.localStorage.removeItem("companyId")
                            window.localStorage.removeItem("companyRoleType")
                            window.localStorage.removeItem("companyName")
                            this.user='';
                            this.$router.push({
                                path: '/pages/login/PcLogin'
                            });
                        }
                        if (res.data == -1) {
                            this.$message({
                                type: 'warning',
                                message: '程序错误!'
                            });
                        }
                    }
                });


            }).catch((e) => {
                console.log(e);
                this.$message({
                    type: 'info',
                    message: '已取消'
                });
            });
        },//退出登录？
    },
    computed: {
        userInfo() {
            if(this.user) {
                return {
                    name: this.user.nickname,
                    // svg: require(this.$isMobile ? "@/assets/svg/m_userLevel/user.svg" : "@/assets/svg/userLevel/user.svg"),
                    svg: require("@/assets/image/user.svg"),
                }
            }
            else return null;
        },
        //判断是否为微信内置
        // isWeiXin() {
        //     var ua = window.navigator.userAgent.toLowerCase();
        //     if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        //         return true;
        //     } else {
        //         return false;
        //     }
        // },
        loginStatus() {
            return window.localStorage.getItem("user")
        },  //判断登录状态
        pageLink() {
                return ZtyHeaderLinks
        },
        logoItem() {
            return  [
                require("@/assets/image/headerLogo.png"),
            ]
        },
        logoUrl() {
                return this.logoItem[0];
        }
    },
    watch: {
        '$route.fullPath': {
            handler(val) {
                for (let item of this.pageLink) {
                    if (item.type == 'menu') {
                        let active = item.children.find(link => {
                            return val.indexOf(link.url) != -1
                        })
                        if (active) {
                            this.activePageLinkIndex = active.index
                            break
                        }
                    }
                }
            },
            immediate: true
        }
    }
}

export default headerMixin